import {useState} from "react";
import {Box, Stack, Typography} from "@mui/material";
import GuacamoleClient from "@/pages/Service/Internal/Internal.Opennebula/components/GuacamoleClient";
import styles from "../style.module.scss"

export default function GuacamoleConsole({name, url, token}: any) {
    const [guac, setGuac] = useState<any>(null);  // State to store the Guacamole client instance

    const context = {
        url,
        token,
        guac,
        setGuac
    }

    const onSendCtrlAltDel = () => {
        if (guac) {
            const CTRL_KEY = 0xFFE3;   // KeySym for CTRL
            const ALT_KEY = 0xFFE9;    // KeySym for ALT
            const DELETE_KEY = 0xFFFF; // KeySym for DELETE (Redefine DELETE's keysym if needed)

            // Programmatically send [CTRL] + [ALT] + [DELETE] sequence
            // Note: `guac.sendKeyEvent(pressed, keysym)` (pressed: 1 means keyDown, 0 means keyUp)

            // Key Down CTRL and ALT
            guac.sendKeyEvent(1, CTRL_KEY); // CTRL key down
            guac.sendKeyEvent(1, ALT_KEY);  // ALT key down

            // Send DELETE key press and release
            guac.sendKeyEvent(1, DELETE_KEY); // DELETE key down
            guac.sendKeyEvent(0, DELETE_KEY); // DELETE key up

            // Key Up CTRL and ALT (release)
            guac.sendKeyEvent(0, ALT_KEY);   // ALT key up
            guac.sendKeyEvent(0, CTRL_KEY);  // CTRL key up
        }
    };

    return (
        <>
            <Stack justifyContent="start" alignItems="center" sx={{
                bgcolor: 'black',
                minHeight: '100vh'
            }}>
                <Box sx={{p: '12px', width: '100%', height: 82}}>
                    <Typography
                        fontSize={15}
                        fontWeight={600}
                        whiteSpace="nowrap"
                        color="white"
                        fontFamily="Arial, sans-serif"
                        lineHeight="normal"
                    >
                        {name}
                    </Typography>
                    <button onClick={() => onSendCtrlAltDel()} className={styles.Button}>
                        Send Ctrl+Alt+Delete
                    </button>
                    <button onClick={() => window.location.reload()} className={styles.Button} style={{width: 60, marginRight: 8}}>
                        Reload
                    </button>
                </Box>
                <GuacamoleClient {...context}/>
            </Stack>
        </>
    )
}